/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_puedeAccion as puedeAccion,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ReunionesProyecto as ReunionesProyecto,
} from "../../runtime/index.jsx";
export function Componente_ZO_90_79(e) {
  let t = (0, ReactCompiler.c)(7),
    { unidadId: n, unidadNombre: r, proyectos: i } = e,
    a;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = []), (t[0] = a))
    : (a = t[0]);
  let o;
  t[1] !== n || t[2] !== r
    ? ((o = {
        id: null,
        unidadId: n,
        nombre: r,
        miRol: `COLABORADOR`,
        // Reuniones del área: lo que el usuario puede en esta unidad (permisos por acción).
        misAcciones: [`planner.reuniones.ver`, `planner.reuniones.crear`, `planner.reuniones.editar`, `planner.reuniones.eliminar`].filter((c) => puedeAccion(c, n)),
        miembros: a,
      }),
      (t[1] = n),
      (t[2] = r),
      (t[3] = o))
    : (o = t[3]);
  let s;
  return (
    t[4] !== i || t[5] !== o
      ? ((s = (
          <section
            className={`flex flex-col gap-2`}
            children={<ReunionesProyecto proyecto={o} proyectosDelArea={i} />}
          />
        )),
        (t[4] = i),
        (t[5] = o),
        (t[6] = s))
      : (s = t[6]),
    s
  );
}
